import React, {Component} from 'react';

class Footer extends Component {
  render() {
    return (
      <div id="footer">
          <div className="row">
            <div className="footer-text">
            <p>Copyright © 2020 Moore Benefit Resources. All Rights Reserved.</p>
            </div>
          </div>
      </div>
    )
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js